/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Default_Accessorials_DescriptionInputs */

const en_default_accessorials_description = /** @type {(inputs: Default_Accessorials_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select default accessorial charges for checkout`)
};

const es_default_accessorials_description = /** @type {(inputs: Default_Accessorials_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona cargos adicionales predeterminados para checkout`)
};

/**
* | output |
* | --- |
* | "Select default accessorial charges for checkout" |
*
* @param {Default_Accessorials_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const default_accessorials_description = /** @type {((inputs?: Default_Accessorials_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Default_Accessorials_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_default_accessorials_description(inputs)
	return es_default_accessorials_description(inputs)
});